module.exports = __webpack_public_path__ + "static/media/school-pink.1be3c147.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/school-pink.svg
// module id = 114
// module chunks = 0